import { NgModule } from '@angular/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { RouterModule, Routes } from '@angular/router'
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component'
import { LoginComponent } from './login/login.component'
import { ResetPasswordComponent } from './reset-password/reset-password.component'
import { NotFoundComponent } from './not-found/not-found.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'brand-login', component: LoginComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'brand-reset-password', component: ResetPasswordComponent },

  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'brand-forgot-password', component: ForgotPasswordComponent },
  { path: 'page-not-found', component: NotFoundComponent },
  // { path: '**', component: LoginComponent },
  { path: '', loadChildren: './home/home.module#HomeModule' },
  // { path: '', loadChildren: (): any => import(`./home/home.module`) },
  { path: '**', redirectTo: '/page-not-found', pathMatch: 'full' }
  ]

@NgModule({
  imports: [RouterModule.forRoot(routes), BrowserAnimationsModule],
  exports: [RouterModule],
})
export class AppRoutingModule {}
